import React from "react"
import { useNavigate } from "react-router-dom"
import { Container, Card, Button } from "react-bootstrap"

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <Container fluid className="d-flex justify-content-center align-items-center" style={{ height: "100vh", backgroundColor: "gray" }}>
      <Card className="text-center shadow" style={{ maxWidth: "360px", padding: "32px 24px", borderRadius: "5px" }}>
        <Card.Body>
          <Card.Title as="h1" className="text-danger" style={{ fontSize: "36px", fontWeight: "bold" }}>404</Card.Title>
          <Card.Subtitle as="h2" className="mb-3" style={{ fontSize: "22px", fontWeight: 300 }}>Page Not Found</Card.Subtitle>
          <Card.Text style={{ fontSize: "14px", lineHeight: "1.4", color: "rgba(0, 0, 0, 0.87)" }}>
            This route was not found on this website. Please check your URL.
          </Card.Text>
          <Card.Text style={{ fontSize: "14px", lineHeight: "1.4", color: "rgba(0, 0, 0, 0.87)" }}>
            This page was generated by the application.
          </Card.Text>
          <Button variant="primary" className="mt-3" onClick={() => navigate("/")}>
            Back to Home
          </Button>
        </Card.Body>
      </Card>
    </Container>
  )
}